import {Inject, Injectable, Optional} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {GET_ATTACHMENT_DOWNLOAD_URL, IDownloadUrlResponse} from '@shared-models/common.models';

@Injectable({
    providedIn: 'root'
})
export class AttachmentService {

    constructor(
        private httpClient: HttpClient,
        @Optional() @Inject(GET_ATTACHMENT_DOWNLOAD_URL) private getDownloadUrl: string,
    ) {
    }

    getAttachmentDownloadUrl(uId: string): Observable<any> {
        const url = this.getDownloadUrl.replace('{uId}', uId);
        return this.httpClient.get(url) as Observable<IDownloadUrlResponse>;
    }
}
